/**
 * Route for `igaming-sub-affiliate`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingSubAffiliatePage } from "../features/igaming-sub-affiliate/IgamingSubAffiliatePage";

export const igamingSubAffiliateRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-sub-affiliate",
	component: IgamingSubAffiliatePage,
});

export default igamingSubAffiliateRoute;
